"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
require("../bootstrap");
require("../plugins/ajax");
require("../plugins/buttons");
require("../plugins/clipboard");
require("../plugins/echo");
require("../plugins/location");
require("../plugins/materialize");
require("../plugins/select2");
require("../plugins/user-broadcast-notifications");
var jquery_1 = __importDefault(require("jquery"));
var Root_1 = __importDefault(require("./react/Root"));
if (document.getElementById('react-container')) {
    react_dom_1.default.render((0, jsx_runtime_1.jsx)(Root_1.default, {}), document.getElementById('react-container'));
}
/*
 * EXPLICIT MATERIALIZE LABEL ACTIVATION
 * -----------------------
 * This is to activate Materialize labels
 * so the label is dislayed above field if value.
 * (if  active is added in blade it is removed again)
 *
 */
(function ($) {
    // give password managers some time
    setTimeout(function () {
        $('input').each(function () {
            var that = this;
            // only certain type of input fields
            if (that.type && ['text', 'email', 'password'].includes(that.type)) {
                if (that.name && that.name.length > 0) {
                    // skip debug bar items
                    if (!['uri', 'ip'].includes(that.name)) {
                        var elem = $('label[for="'.concat(that.name, '"]'));
                        if (typeof elem !== 'undefined') {
                            // @todo here i fake the email and password val() given them are still empty with a password manager
                            if ((typeof $('#'.concat(that.id)).val() !== 'undefined' && $('#'.concat(that.id)).val()) ||
                                ['email', 'password'].includes(that.id)) {
                                elem.addClass('active');
                            }
                        }
                    }
                }
            }
        });
    }, 1000);
})(jquery_1.default);
